import "babel-polyfill";
import Vue from 'vue'
import VueResource from 'vue-resource'
import setting from './setting';
import App from './App.vue'

// import '../semantic/dist/semantic.css'

Vue.use(VueResource);

Vue.http.options.emulateJSON = true;

const app = new Vue({
    el: '#app',
    components: {
        App
    },
    render: h => h('App'),
});


// WEBPACK FOOTER //
// ./src/main.js